import LocationAdapter from '@javascripts/adapters/location_adapter';
import TopicAdapter from '@javascripts/adapters/topic_adapter';
import FullscreenApiAdapter from '@javascripts/adapters/fullscreen_api_adapter';

export default class BlockerButtonHelper {
  static create({type = 'black', text, onclick, tagOptions = {}}){
    let element = document.createElement("div");
    element.className = `vjs-player-error__button-revamp vjs-player-error__${type}-cta-button`;
    element.innerHTML = `<a class="vjs-player-error__${type}-link vjs-player-error__link-revamp">${text}</a>`;
    element.firstChild.onclick = onclick;

    if(tagOptions.href) element.firstChild.href = tagOptions.href;

    return element;
  }

  constructor(options = {}) {
    this._tech = options.tech;
    this._data = options.data;
  }

  get tech() {
    return this._tech;
  }
  get data() {
    return this._data;
  }

  retryButton({ text, type }) {
    return BlockerButtonHelper.create({
      type,
      text,
      onclick: this.onClickRetryButton.bind(this),
    });
  }

  onClickRetryButton() {
    let type;
    if (this.data.isVideo()) type = 'vp-retry-button-click';
    if (this.data.isLivestreaming()) type = 'vp-livestream-retry-button-click';

    this.tech.trigger({ type });
    LocationAdapter.reload();
  }

  downloadButton({ type }) {
    let href = 'https://app.vidio.com/appdownload-errorblocker';
    return BlockerButtonHelper.create({
      type,
      text: 'Download App',
      onclick: this.onClickDownloadButton.bind(this),
      tagOptions: { href: href },
    });
  }

  onClickDownloadButton() {
    let type;
    if (this.data.isVideo()) type = 'vp-download-app-button-click';
    if (this.data.isLivestreaming())
      type = 'vp-livestream-download-app-button-click';

    this.tech.trigger({ type });
  }

  exploreVidioButton({ text, type }) {
    let href = 'https://www.vidio.com';
    return this.withDirectLinkButton({ text, href, type} );
  }

  withDirectLinkButton({text, href, type}) {
    return BlockerButtonHelper.create({
      type,
      text,
      onclick: this.onClickHrefButton.bind(this),
      tagOptions: { href: href },
    });
  }

  onClickHrefButton() {
    let type;
    if (this.data.isVideo()) type = 'vp-href-button-click';
    if (this.data.isLivestreaming()) type = 'vp-livestream-href-button-click';

    this.tech.trigger({ type });
  }

  reportButton({ text, code, type }) {
    return BlockerButtonHelper.create({
      type,
      text,
      onclick: this.onclickReportButton.bind(this, code)
    });
  }

  waitFullscreenExited(interval) {
    return new Promise(resolve => {
      const exitFsInterval = setInterval(() => {
        if (!this.tech.isFullscreen()) {
          clearInterval(exitFsInterval)
          resolve()
        }
      }, interval);
    })
  }

  publishSendFeedbackTopic(code) {
    TopicAdapter.publish('watchpage/send_feedback/show', {
      issue_category_code: 'icc4',
      issue_code: 'pi01',
      error_code: String(code),
    })
  }

  onclickReportButton(code) {
    let type;

    if (this.data.isVideo()) type = 'vp-report-button-click';
    if (this.data.isLivestreaming()) type = 'vp-livestream-report-button-click';

    this.tech.trigger({ type });

    if (this.tech.isFullscreen()) {
      FullscreenApiAdapter.exitFullscreen();
      this.waitFullscreenExited(10).then(() => this.publishSendFeedbackTopic(code))
    } else {
      this.publishSendFeedbackTopic(code)
    }
  }
}
